import { InputHTMLAttributes, forwardRef } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: "top" | "middle" | "bottom" | "standalone";
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant = "standalone", className = "", ...props }, ref) => {
    const baseClasses =
      "appearance-none relative block w-full px-3 py-2 border border-border placeholder-gray-500 text-text-primary bg-bg-primary focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 text-md";

    const variantClasses = {
      top: "rounded-t-md rounded-none",
      middle: "rounded-none",
      bottom: "rounded-b-md rounded-none",
      standalone: "rounded-md",
    };

    const disabledClasses = props.disabled ? "disabled:bg-gray-100" : "";

    return (
      <input
        ref={ref}
        className={`${baseClasses} ${variantClasses[variant]} ${disabledClasses} ${className}`}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export default Input;
